import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { ListWhitelabelConfigsPage } from "@/features/whitelabel";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/whitelabel/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    if (userData?.user?.roleName !== USER_ROLES.SUPER_ADMIN) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Whitelabel Configs");

  return <ListWhitelabelConfigsPage />;
}
